module.exports = __webpack_public_path__ + "img/bgtop.9bf32ec6.jpg";